export const getProfile = (data, options = {}) => {
  return {
    type: "GET_PROFILE",
    payload: data,
    meta: { silent: !!options.silent },
  };
};

export const getSastoken = (data) => {
  return {
    type: "GET_SAS_TOKEN",
    payload: data,
  };
};
